export const icons = {
  props: {},
  SectionHeader: {
    props: {
      margin: '- - B1'
    },
    heading: {
      Title: {
        text: '{{ editor.panel.icons | polyglot }}'
      }
    },
    nav: {
      add: {
        props: () => ({
          icon: 'plus',
          href: window.location.pathname + '/add-icon'
        })
      }
    }
  },
  Flex: {
    flow: 'y',
    gap: 'C1',
    lazyLoad: true,
    childExtends: 'IconsGroup',
    childrenAs: 'state',
    children: (el) => false
  }
}
